<template>
  <v-data-table
      :headers="headers"
      :items="dueData"
      :items-per-page="5"
      class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar dense flat>
        Due Payments
      </v-toolbar>
    </template>
    <template v-slot:no-data>
      Due table is empty!
    </template>
    <template v-slot:item.paymentStatus="{ item }">
      <g-payment-status-chip v-if="item.paymentStatus === 100"/>
    </template>
    <template v-slot:item.createdAt="{ item }">
      {{getDate(item.createdAt)}}
    </template>
    <template v-slot:item.totalAmount="{ item }">
      ${{item.totalAmount}}
    </template>
  </v-data-table>
</template>

<script>
import GPaymentStatusChip from "../GPaymentStatusChip";
import DateHelper from "../mixins/DateHelper";
export default {
  name: "DueDataTable",
  components: {GPaymentStatusChip},
  mixins: [DateHelper],
  data() {
    return {
      headers: [
        {
          text: 'Invoice No',
          value: 'invoiceNo'
        },
        {
          text: 'Created At',
          value: 'createdAt'
        },
        {
          text: 'Payment Status',
          value: 'paymentStatus'
        },
        {
          text: 'Total Amount',
          value: 'totalAmount',
          align: 'right'
        }
      ]
    }
  },
  props: {
    dueData: {
      type: Array,
      default: function () {
        return []
      }
    },
    symbol: {
      type: String,
      default: function (){
        return '$'
      }
    },
    bdt: {
      type: Number,
      default: function (){
        return 1
      }
    }
  }
}
</script>

<style scoped>

</style>